import {Component} from "@angular/core";
import {detectBody} from "../app.helpers";

declare let jQuery: any;


@Component({
	selector: "basic",
	templateUrl: "basicLayout.template.html",
  host: {
	  "(window:resize)": "onResize()"
  }
})
export class BasicLayoutComponent
{
	
	
	/**
	 * Function > ngOnInit
	 * @returns {void}
	 */
	public ngOnInit(): void
	{
      detectBody();
	} // end function ngOnInit
	
	
	/**
	 * Function > onResize
	 * @returns {void}
	 */
	public onResize(): void
	{
      detectBody();
	} // end class onResize
	
	
} // end class BasicLayoutComponent